"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LambdaLevelValue = exports.isLogLevel = exports.logLevels = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["SPECIAL"] = 0] = "SPECIAL";
    /** Important System status messages, always log - to be used to flag valid but notable events */
    LogLevel[LogLevel["SYSTEM"] = 1] = "SYSTEM";
    LogLevel[LogLevel["TRACE"] = 2] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 4] = "INFO";
    LogLevel[LogLevel["WARN"] = 5] = "WARN";
    LogLevel[LogLevel["ERROR"] = 6] = "ERROR";
    LogLevel[LogLevel["FATAL"] = 7] = "FATAL";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
exports.logLevels = ['SPECIAL', 'SYSTEM', 'TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'FATAL'];
const isLogLevel = (level) => {
    return typeof level === 'string' && exports.logLevels.includes(level);
};
exports.isLogLevel = isLogLevel;
exports.LambdaLevelValue = {
    FATAL: 0,
    SPECIAL: 0,
    SYSTEM: 0,
    ERROR: 1,
    INFO: 2,
    WARN: 3,
    DEBUG: 4,
    TRACE: 5,
    [LogLevel.FATAL]: 0,
    [LogLevel.SPECIAL]: 0,
    [LogLevel.SYSTEM]: 0,
    [LogLevel.ERROR]: 1,
    [LogLevel.INFO]: 2,
    [LogLevel.WARN]: 3,
    [LogLevel.DEBUG]: 4,
    [LogLevel.TRACE]: 5,
};
